export function formatNumberTwoDigit(number) {
  if (number < 10) {
    return `0${number}`;
  } else if (number < 100){
    return number.toString();
  } else {
    return undefined;
  }
}
